.workflow-history-modal {
  --height: 60%;
  --width: 90%;
  --max-width: 500px;
}

.workflow-history-modal ion-content {
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 16px;
  --padding-bottom: 16px;
}

.workflow-history-modal ion-item {
  --padding-start: 0;
  --inner-padding-end: 0;
  margin-bottom: 8px;
  border-radius: 8px;
  --background: var(--ion-color-light);
}

.workflow-history-modal ion-avatar {
  width: 40px;
  height: 40px;
}

.workflow-history-modal ion-label h2 {
  font-weight: bold;
  color: var(--ion-color-primary);
  margin-bottom: 4px;
}

.workflow-history-modal ion-label p {
  margin: 2px 0;
  font-size: 0.9em;
  color: var(--ion-color-medium);
}
